import { APIEndPoint } from 'src/shared/constants/api-endpoint';
import { apiGet, apiPost } from 'src/shared/utils/api-request';
import { getUserTimezone } from 'src/shared/utils/utils';
import { ChatBotQuestions } from '../model';

export const askChatBotQuestion = async ({
  query,
  userId,
  sessionId
}: {
  query: string;
  userId: string;
  sessionId: string;
}) => {
  const res = await apiPost(`${APIEndPoint?.dataCopilot?.chat}`, {
    query,
    userUid: userId,
    sessionId: sessionId
  });
  return res?.data || [];
};

export const getChatBotQuestions = async (): Promise<ChatBotQuestions[]> => {
  const res = await apiGet(`${APIEndPoint?.dataCopilot?.categoryQuestions}`);
  return res?.data || [];
};

export const downloadChatBotResponse = async (props) => {
  const { chatId, format } = props;
  const timezone = getUserTimezone();
  
  const res = await apiGet(
    `${APIEndPoint?.dataCopilot?.chatDownload}/${chatId}/${APIEndPoint?.dataCopilot?.export}`,
    {
      responseType: 'blob',
      params: { format, timezone }
    }
  );
  return res;
};

